import { Card, Col, Row, Button, Form } from 'antd';
import React, { useCallback, useState } from 'react';
import { BASE_GUTTER } from 'constants/Layout';
import message from "components/CustomMessage";
import { FieldTypes, domainRegexValidator, generateFormFields, nameRegexValidator } from 'utils/formUtils';
import { SuperAdminAPI } from 'restAPI/SuperAdminAPI';

const colProps = {
  lg: 10,
  md: 12,
  sm: 16,
  xs: 24,
  style: { margin: "auto", marginTop: "20px" }
};

export const TYPE_OPTIONS = ["Prod", "Sandbox", "QA", "Internal", "Partner"];

export default function CreateTenant() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const submit = useCallback((data) => {
    setLoading(true);
    const tenantDTO = {
      name: data.name,
      domain: data.domain,
      type: data.type
    }
    const { promise, cancel } = SuperAdminAPI.createTenant(tenantDTO);
    promise.then(() => {
      message.success(`Successfully created Account - ${data.name}`);
      form.resetFields();
    })
    .finally(() => {
      setLoading(false);
    });
    return cancel;
  }, [form])

  const fields = useCreateTenantFields();

  return (
    <div className="login-page">
      <Row>
        <Col {...colProps}>
          <Card
            bordered={false}
            className="login-box"
            title="Create an Account"
          >
            <Row gutter={BASE_GUTTER} className="p-sm">
              <Col span={24}>
                <Form
                  layout="vertical"
                  form={form}
                  onFinish={submit}
                >
                  {generateFormFields(fields)}
                  <Row>
                    <Col span={12}>
                      <Button href="/#" type="primary">Back Home</Button>
                    </Col>
                    <Col span={12}>
                      <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                        <Button loading={loading} className='pull-right' type="primary" htmlType="submit">
                          Submit
                        </Button>
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>

    </div>
  )
}

export const useCreateTenantFields = ({ nameFieldValidator } = {}) => {
  return [{
    name: "name",
    label: "Account Name",
    rules: [
      {
        required: true,
        message: "Enter an account name"
      },
      nameRegexValidator({ regex: /^[A-Za-z]+[.A-Za-z0-9 _&-]*/g, message: "Alphanumeric with space, hyphen, underscore, period and ampersand are allowed." }),
      ...(nameFieldValidator ? [{ validator: nameFieldValidator }] : [])
  ],
  },
  {
    name: "domain",
    label: 'Email Domain',
    help: <>Provide the email domain of the customer.</>,
    rules: [domainRegexValidator]
  },
  {
    name: "type",
    label: "Type",
    required: true,
    type: FieldTypes.SELECT,
    options: TYPE_OPTIONS
  }]
};
